import { Component, Input } from '@angular/core';

import { ChannelReachItem } from './chanel-reach-item';

@Component({
    selector: 'channel-reach-item',
    templateUrl: './channel-reach-item.component.html',
    styleUrls: ['./channel-reach-item.component.scss']
})
export class ChannelReachItemComponent {
    @Input() item: ChannelReachItem;
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/channel-reach/channel-reach-item/channel-reach-item.component.ts